import { Button } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { useSyncStripe } from '@/hooks/useRevenue';

export function StripeSync() {
  const syncStripe = useSyncStripe();

  const handleSync = () => {
    syncStripe.mutate(undefined, {
      onSuccess: (result) => {
        notifications.show({
          title: 'Stripe-Sync',
          message: `${result.importedCount} Transaktionen importiert.`,
          color: 'green',
        });
      },
      onError: () => {
        notifications.show({
          title: 'Fehler',
          message: 'Stripe-Synchronisierung fehlgeschlagen.',
          color: 'red',
        });
      },
    });
  };

  return (
    <Button
      variant="light"
      leftSection={<IconRefresh size={16} />}
      onClick={handleSync}
      loading={syncStripe.isPending}
    >
      Stripe synchronisieren
    </Button>
  );
}
